import { Nullable } from 'vitest';

import { genesisAirdropControllerApi } from '../../clients/clients';
import { GetTeamBoostHistory14YxddURequest } from '../../generated';

export type TeamBoostHistoryParam = {
  userAddress: Nullable<GetTeamBoostHistory14YxddURequest['userAddress']>;
  page: number;
  size: number;
};

const getKey = (params: TeamBoostHistoryParam) => {
  return ['genesisAirdropControllerApi', 'teamBoostHistoryParam', params];
};
const getFn =
  ({ ...params }: TeamBoostHistoryParam) =>
  async () => {
    if (!params.userAddress) {
      throw new Error('Query should not be called');
    }

    return genesisAirdropControllerApi.getTeamBoostHistory14YxddU({
      userAddress: params.userAddress,
      page: params.page,
      size: params.size,
    });
  };

export const teamBoostHistoryQuery = {
  getKey,
  getFn,
};
